module.exports = __webpack_public_path__ + "static/media/webflows.21cabe92.svg";